<template>
  <div class="aboutpage5">
    <div class="w-main">
      <div v-html="content" class="aboutpage5-box"></div>
    </div>
  </div>
</template>

<script>
import { getRulesRegulation } from "@/api/api.js";

export default {
  name: "PcHome",
  components: {},
  data() {
    return {
      content: "暂无数据"
    };
  },
  mounted() {
    this.getRulesRegulation();
  },
  methods: {
    getRulesRegulation() {
      getRulesRegulation().then(res => {
        if (res.code === 0) {
          this.content = res.data.content ? res.data.content : "暂无数据";
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    }
  }
};
</script>

<style lang="less">
.aboutpage5 {
  .aboutpage5-box {
    width: 100%;
    padding: 0 16px;
    box-sizing: border-box;
  }
}
</style>
